<div class="dashboard-page">
  <app-dashboard-toolbar
    [username]="username()"
    [isDefault]="isDefault()"
    [von]="von()"
    [bis]="bis()"
    [configOpen]="configOpen()"
    [config]="config()"
    (vonChange)="onVonChange($event)"
    (bisChange)="onBisChange($event)"
    (toggleConfig)="onToggleConfig()"
    (sectionToggle)="onSectionToggle($event)"
    (resetToDefault)="onResetToDefault()"
    (closeConfig)="onCloseConfig()"
  />

  @if (showsStaleData()) {
    <app-live-reconnect-hint data-testid="dashboard-stale-hint" messageKey="liveDashboard.staleHint" />
  }

  <div class="dashboard-page__content">
    @if (hasNoProjects()) {
      <app-dashboard-empty-no-project />
    } @else if (allSectionsHidden()) {
      <app-dashboard-empty-all-hidden />
    } @else {
      @if (config()?.sections?.livePipeline) {
        <app-live-pipeline-section />
      }

      @if (config()?.sections?.testKpis && data()?.testKpis) {
        <app-testmanager-kpis [kpis]="data()!.testKpis" />
      }

      @if (config()?.sections?.testProgress) {
        <div class="dashboard-page__grid-2">
          <app-test-progress [projects]="data()?.testProgress ?? []" />
          <app-top-failures [failures]="data()?.topFailures ?? []" />
        </div>
      }

      @if (config()?.sections?.testFunnel) {
        <app-requirements-funnel [projects]="projectFunnels()" />
      }

      @if (config()?.sections?.qualitaet && data()?.qualitaet) {
        <app-qualitaet-section [qualitaet]="data()!.qualitaet" />
      }

      @if (config()?.sections?.devopsKpis) {
        <app-devops-kpis />
      }

      @if (config()?.sections?.devopsPipeline) {
        <app-devops-pipeline-health />
      }

      @if (config()?.sections?.devopsBuilds) {
        <app-devops-builds-incidents />
      }

      @if (config()?.sections?.activity && data()?.activity) {
        <app-activity-feed [activity]="data()!.activity" />
      }
    }
  </div>
</div>
